module.exports = __webpack_public_path__ + "img/payment_systems.d7d7a7ed.png";